import { useEffect } from 'react'

import { i18n } from '../i18n'

const TermsOfUsePage = () => {
  const titleTerms = i18n.translate('termsOfUseAgreement')

  useEffect(() => {
    document.title = titleTerms
  }, [titleTerms])

  return (
    <div className="min-h-screen bg-imovWhiteShadow">
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-10">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
          {titleTerms}
        </h1>
        <div className="w-full">
        <p className="mb-6">
          Welcome to <strong>Easy Bail</strong>, a product of{' '}
          <strong>Easy Bail Company</strong>. By accessing and using our website
          and services (collectively, "the Service"), you agree to be bound by
          the following Terms of Use ("Terms"). If you do not agree with these
          Terms, please do not use the Service.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          1. Acceptance of Terms
        </h2>
        <p className="mb-6">
          By using our Service, you accept and agree to be bound by these Terms.
          If you do not agree to these Terms, please refrain from using the
          Service.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">2. Eligibility</h2>
        <p className="mb-6">
          You must be at least [13/18] years old to use this Service. If you are
          under the age of [13/18], you may not use the Service. By agreeing to
          these Terms, you represent that you are at least [13/18] years old.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          3. Account Registration
        </h2>
        <p className="mb-6">
          To access certain features of the Service, you may be required to
          create an account. You agree to provide accurate, complete, and
          up-to-date information during registration and to maintain the
          security of your account credentials.
        </p>

        <p className="mb-6">
          You are responsible for maintaining the confidentiality of your
          account and password.
        </p>

        <p className="mb-6">
          You agree to immediately notify us of any unauthorized use of your
          account or password.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          4. Use of the Service
        </h2>
        <p className="mb-6">
          You agree to use the Service only for lawful purposes and in
          accordance with these Terms. You may not:
        </p>
        <ul className="list-disc ml-8 mb-6">
          <li>
            Violate any applicable law, regulation, or third-party rights.
          </li>
          <li>Interfere with or disrupt the functionality of the Service.</li>
          <li>
            Engage in any activity that may harm the Service, other users, or
            third parties.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          5. Prohibited Content
        </h2>
        <p className="mb-6">
          You are prohibited from uploading, posting, or sharing any content
          that:
        </p>
        <ul className="list-disc ml-8 mb-6">
          <li>Is illegal, defamatory, or harmful.</li>
          <li>Violates intellectual property rights.</li>
          <li>Infringes on privacy or other legal rights of individuals.</li>
          <li>Promotes hate speech, violence, or discrimination.</li>
        </ul>

        <p className="mb-6">
          We reserve the right to remove any content that violates these
          policies.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          6. Intellectual Property
        </h2>
        <p className="mb-6">
          All intellectual property rights in the Service, including but not
          limited to the content, graphics, logos, trademarks, and software, are
          owned by <strong>Easy Bail Company</strong> or its licensors. You may
          not copy, modify, distribute, or otherwise use the content without
          prior written consent from the owner.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">7. Privacy</h2>
        <p className="mb-6">
          We respect your privacy and handle your personal information in
          accordance with our <strong>[Privacy Policy]</strong>. By using the
          Service, you consent to our data collection and usage practices.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">8. Termination</h2>
        <p className="mb-6">
          We may suspend or terminate your access to the Service if you violate
          these Terms or for any other reason at our discretion. Upon
          termination, all rights granted to you under these Terms will
          immediately end.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">9. Disclaimers</h2>
        <p className="mb-6">
          The Service is provided "as is," and we make no representations or
          warranties regarding the accuracy, reliability, or availability of the
          Service. We are not liable for any damages or losses arising from the
          use or inability to use the Service.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          10. Limitation of Liability
        </h2>
        <p className="mb-6">
          To the maximum extent permitted by law,{' '}
          <strong>Easy Bail Company</strong> is not liable for any indirect,
          incidental, or consequential damages arising out of or in connection
          with your use of the Service, including but not limited to loss of
          data, profits, or business opportunities.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">11. Indemnification</h2>
        <p className="mb-6">
          You agree to indemnify and hold harmless{' '}
          <strong>Easy Bail Company</strong>, its officers, employees, and
          affiliates from any claims, losses, damages, or liabilities arising
          out of your use of the Service, including violations of these Terms.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">12. Governing Law</h2>
        <p className="mb-6">
          These Terms are governed by the laws of{' '}
          <strong>Quebec, Canada</strong>, without regard to its conflict of of
          law principles. Any disputes arising under these Terms shall be
          subject to the exclusive jurisdiction of the courts located in{' '}
          <strong>Quebec, Canada</strong>.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          13. Changes to Terms
        </h2>
        <p className="mb-6">
          We may update or revise these Terms at any time. Any changes will be
          posted on this page with an updated "Last Revised" date. Your
          continued use of the Service after changes to these Terms signifies
          your acceptance of the revised Terms.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">
          14. Non-Disclosure Agreement (NDA)
        </h2>
        <p className="mb-6">
          Confidentiality Obligations By accessing or using this website or
          service, you agree to maintain the confidentiality of any proprietary
          or confidential information shared by the company or through the
          website. You will not disclose, copy, or use any confidential
          information for any purposes other than those explicitly authorized.
        </p>
        <p className="mb-6">
          Definition of Confidential Information "Confidential Information"
          includes all non-public information provided by the company or shared
          through the website, including but not limited to business plans,
          technical data, financial information, trade secrets, user data, and
          any other information designated as confidential.
        </p>
        <p className="mb-6">
          Exclusions The confidentiality obligations do not apply to information
          that:
        </p>
        <ul className="list-disc ml-8 mb-6">
          <li>Is illegal, defamatory, or harmful.</li>
          <li>
            Is publicly available at the time of disclosure or becomes publicly
            available through no fault of the user.
          </li>
          <li>
            Is rightfully obtained by the user from a third party without
            violation of any confidentiality obligation.
          </li>
          <li>Is disclosed with the prior written consent of the company.</li>
        </ul>
        <p className="mb-6">
          Duration of Obligation The confidentiality obligations shall remain in
          effect during the term of your use of the website or service and
          continue indefinitely after the termination or cessation of the use of
          the website or service.
        </p>
        <p className="mb-6">
          Breach of Confidentiality Any unauthorized disclosure or misuse of
          confidential information may result in legal action, including but not
          limited to termination of access to the website or service and
          compensation for damages.
        </p>

        <h2 className="text-xl font-semibold mt-4 mb-2">15. Contact Us</h2>
        <p className="mb-6">
          If you have any questions or concerns regarding these Terms, please
          contact us at:
        </p>
        <ul className="list-none mb-6">
          <li>
            Email: <strong>contact@passemoitonbail.ca</strong>
          </li>
          <li>
            Phone: <strong>(581) 333-3333</strong>
          </li>
          <li>
            Address: <strong>Boulevard de la Gare, Lévis, QC, Canada</strong>
          </li>
        </ul>
        </div>
      </main>
    </div>
  )
}

export default TermsOfUsePage
